import { Box, Icon, Text } from "@salestrak/ui";

import { EntityTag } from "#app/components/entity";
import type { QuickFilterOption } from "./quick-filter-options";

/**
 * How ONE quick-filter value reads on screen — an entity chip when the value
 * IS an entity, a glyph beside its name when it is a named state.
 *
 * Shared by every surface that lists options rather than summarizing them
 * (the cross-section search rows, the checkbox sections), so a member looks
 * the same wherever the panel offers them.
 */
export function QuickOptionFace({ option }: { option: QuickFilterOption }) {
  if (option.entity) {
    return (
      <EntityTag
        entity={option.entity}
        size="sm"
        weight="regular"
        interactive={false}
      />
    );
  }
  return (
    <Box direction="row" align="center" gap="sm" shrink minWidth={0}>
      {option.icon ? (
        <Icon name={option.icon} size="sm" color={option.iconColor} />
      ) : null}
      <Text size="sm" truncate>
        {option.label}
      </Text>
    </Box>
  );
}
